import { nf } from "@/lib/format";
import { L } from "@/i18n";

const moduleNum = (id) => parseInt(String(id).replace(/\D/g, ""), 10) || 0;

const chip = (active) =>
  `rounded-md border px-2.5 py-1 font-mono text-[11px] transition-colors ${
    active ? "border-amber-500 bg-amber-500/15 text-amber-300" : "border-slate-700 text-slate-400 hover:border-slate-500 hover:text-slate-200"
  }`;

export const DuplicateSummary = ({ data, module, onModule }) => {
  const perModule = Object.entries(data?.per_module_extras ?? {}).sort((a, b) => moduleNum(a[0]) - moduleNum(b[0]));
  return (
    <div className="rounded-lg bg-[#131f37] border border-[#1e293b] p-5 sm:p-6 mb-6" data-testid="duplicates-summary">
      <div className="flex flex-wrap gap-8">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">{L("Duplicate groups", "Grupos duplicados")}</p>
          <p className="mt-1 font-mono text-3xl font-bold text-slate-50" data-testid="duplicates-total-groups">{nf.format(data?.total_groups ?? 0)}</p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">{L("Extra copies", "Cópias extra")}</p>
          <p className="mt-1 font-mono text-3xl font-bold text-amber-400" data-testid="duplicates-total-extras">{nf.format(data?.total_extras ?? 0)}</p>
        </div>
      </div>
      <p className="mt-5 mb-2 text-xs text-slate-400">{L("Filter by module (extra copies)", "Filtrar por módulo (cópias extra)")}</p>
      <div className="flex flex-wrap gap-2">
        <button className={chip(module === "all")} onClick={() => onModule("all")} data-testid="duplicates-filter-all">
          {L("All", "Todos")}
        </button>
        {perModule.map(([m, n]) => (
          <button key={m} className={chip(module === m)} onClick={() => onModule(m)} data-testid={`duplicates-filter-${m}`}>
            {m} <span className="text-slate-500">· {n}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
